// extracted by mini-css-extract-plugin
export default {"infoWrapper":"style_infoWrapper__ELZgd","infoTitle":"style_infoTitle__KmT2t","infoText":"style_infoText__AhB-c","alertTitle":"style_alertTitle__1UN5W"};